import assign from 'object-assign';
import getAgendaStore, { createEmptyAgendaStore } from '../store/store';
import { AgendaStore } from '../store/schema/AgendaStore';
import { mutator } from 'satcheljs';
import { resetAgendaStore } from '../actions/publicActions';

/**
 * Mutator to reset the agenda view store.
 */
const resetAgendaStoreMutator = mutator(resetAgendaStore, () => {
    const agendaStore: AgendaStore = getAgendaStore();
    assign(agendaStore, createEmptyAgendaStore());
});

export default resetAgendaStoreMutator;
